(() => {
  'use strict';

  const setFooterCredit = () => {
    const link = document.querySelector('.footer__copyright-content a[href*="exedracore.com"]');
    if (!link) return;

    link.href = 'https://danimarkets.com/';
    link.textContent = 'Danimarkets';

    const previousText = link.previousSibling;
    if (!previousText || !previousText.textContent.includes('Desarrollado por')) {
      link.insertAdjacentText('beforebegin', 'Desarrollado por ');
    }
  };

  setFooterCredit();
  document.addEventListener('shopify:section:load', setFooterCredit);

  const designMode = window.Shopify && window.Shopify.designMode;
  if (designMode) return;

  try {
    console.info(
      '%cMiis Cosmetics Ecuador%c · Implementación técnica: Danimarkets',
      'font-weight:700',
      'font-weight:400'
    );
    console.info('https://danimarkets.com/');
  } catch (error) {
    // Console access is optional and must never affect storefront execution.
  }
})();
